<div class="container mt-2">
  <div class="row h4">{{data.sheetTitle}}</div>

  <div *ngIf="!data.sheetHtml" class="row h6">{{data.sheetText}}</div>
  <div *ngIf="data.sheetHtml" class="row h6" [innerHTML]="data.sheetHtml"></div>
  <div class="float-right">
    <button mat-raised-button class="btn btn-success" (click)="handleOK()">OK</button>
    <button mat-raised-button class="btn btn-danger ml-2" (click)="handleCancel()">Cancel</button>
  </div>
</div>
